import { ModelCurrentTaskProgram } from './model-current-task-program';
import { sumUpValues, mapCollection, first } from '../../utils/collection.utils';
import { BY_PART } from '../../config/modularized.config';
import { environment } from '../../../../environments/environment';

export class ModelCurrentTask {
  constructor(
    public hash: string,
    public startTime: number,
    public identifier: number,
    public waiting: boolean,
    public end: boolean,
    public alarm: boolean,
    public pause: boolean,
    public programs: ModelCurrentTaskProgram[]
  ) { }

  get endTime() {
    const firstProgram = first(this.programs);
    if (environment.summaryModularized === BY_PART && firstProgram) {
      return firstProgram.endTime;
    }
    return this.startTime + sumUpValues(mapCollection(program => program.time, this.programs));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-current-task.ts